export const TRANSITION_ENTER_CLASS = 'enter';
export const TRANSITION_LOADING_CLASS = 'loading';
export const TRANSITION_DEFAULT_CLASS = 'transition';
export const TRANSITION_BODY_LOADING_CLASS = 'transition-loading';
